var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getKitOrderPrepopulateData } from '../services/SprinklerSamplingService';
const kitOrderKeys = {
    prepopulate: (buildingId) => ['kit-order', 'prepopulate', buildingId]
};
export function useKitOrderPrepopulateQuery(buildingId) {
    return useQuery({
        queryKey: kitOrderKeys.prepopulate(buildingId !== null && buildingId !== void 0 ? buildingId : 0),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield getKitOrderPrepopulateData(buildingId !== null && buildingId !== void 0 ? buildingId : 0);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        staleTime: 10 * 60 * 1000,
        cacheTime: 30 * 60 * 1000
    });
}
